import React from 'react';
import { Card, Nav, NavItem, NavLink, Container } from 'reactstrap';

const EarlyAlert = () => {
  return (
    <Container className="early-alerts">
      <h3 className="py-3">Public Health Resources</h3>
      <p className="text-muted">
        These links open trusted external public-health resources in a new tab.
        Return to this VacTrac tab to continue.
      </p>
      <p className="text-muted small">
        VacTrac is a demo application. These resources are provided for educational
        context only and do not constitute clinical advice.
      </p>
      <Nav>
        <ul className="early-alerts px-5">
          <li>
            <NavItem>
              <Card color="info" size="lg">
                <NavLink
                  href="https://www.cdc.gov/vaccines/schedules/hcp/imz/adult.html"
                  target="_blank"
                  rel="noopener noreferrer">
                  <h3>CDC: Adult Immunization Schedule</h3>
                  <small className="text-muted">External resource — opens in new tab</small>
                </NavLink>
              </Card>
            </NavItem>
          </li>

          <li>
            <NavItem>
              <Card color="info" size="lg">
                <NavLink
                  href="https://www.cdc.gov/vaccines/index.html"
                  target="_blank"
                  rel="noopener noreferrer">
                  <h3>CDC: Vaccines &amp; Immunizations</h3>
                  <small className="text-muted">External resource — opens in new tab</small>
                </NavLink>
              </Card>
            </NavItem>
          </li>

          <li>
            <NavItem>
              <Card color="info" size="lg">
                <NavLink
                  href="https://www.who.int/health-topics/vaccines-and-immunization"
                  target="_blank"
                  rel="noopener noreferrer">
                  <h3>WHO: Vaccines and Immunization</h3>
                  <small className="text-muted">External resource — opens in new tab</small>
                </NavLink>
              </Card>
            </NavItem>
          </li>

          <li>
            <NavItem>
              <Card color="info" size="lg">
                <NavLink
                  href="https://wwwnc.cdc.gov/travel"
                  target="_blank"
                  rel="noopener noreferrer">
                  <h3>CDC: Travel Health — Vaccines &amp; Destinations</h3>
                  <small className="text-muted">External resource — opens in new tab</small>
                </NavLink>
              </Card>
            </NavItem>
          </li>

          <li>
            <NavItem>
              <Card color="info" size="lg">
                <NavLink
                  href="https://www.cdc.gov/vaccines-adults/recommended-vaccines/vaccine-planning.html"
                  target="_blank"
                  rel="noopener noreferrer">
                  <h3>CDC: Where to Find Vaccines</h3>
                  <small className="text-muted">External resource — opens in new tab</small>
                </NavLink>
              </Card>
            </NavItem>
          </li>
        </ul>
      </Nav>
    </Container>
  )
}

export default EarlyAlert;
